import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Input,
  FormGroup,
  CustomInput,
  Button,
  ButtonGroup,
  Form,
  Modal,
  ModalBody,
  InputGroup,
  Label
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../components/common/CustomBootstrap';

import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { sortPropertyListByName } from '../../../../../helpers/Utils';

import {
  gAPI_Property_List_By_Group,
  postAPI_Create_PhoneIntegration,
  gAPI_Ingetration,
  putAPI_Update_PhoneIntegration,
  postAPI_Create_PhoneIntegrationInGroupService,
  putAPI_Update_PhoneIngetration_Group
} from '../../../../../constants/APIs';
import short from 'short-uuid';
import Axios from 'axios';
import Validation from '../../../../../components/Validation';

let arr = [];
export default function PhoneIntegration({ visible, toggle, id }) {
  const [property, setProperty] = useState([]);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [inputData, setInputData] = useState({
    GroupId: getGroupID(),
    Name: '',
    propertyId: '',
    SessionTimeoutInSeconds: 600,
    DefaultLanguage: 'en-US',
    Number: ''
  });

  useEffect(() => {
    if (id !== undefined) {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Ingetration}/${id}?group_id=${getGroupID()}`,
      })
        .then(res => {
          console.log(res.data)
          setInputData({ ...inputData, Name: res.data.name, Number: res.data.channelDetails.number, propertyId: res.data.properties[0] });
        })
        .catch(err => console.log('err', err));

      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
      })
        .then(res => {
          setProperty([...res.data]);
        })
        .catch(err => console.error(err));
    }
    else {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
      })
        .then(res => {
          setProperty([...res.data]);
        })
        .catch(err => console.error(err));
    }
  }, [id]);


  const handleNameChange = e => {
    e.persist();
    setInputData({ ...inputData, Name: e.target.value });
  };

  const handleNumberChange = e => {
    e.persist();
    setInputData({ ...inputData, Number: e.target.value });
    console.log(inputData)
  };

  const handleCheckChange = e => {
    if (e.target.checked) {
      setInputData({ ...inputData, propertyId: e.target.value });
    }
    if (!e.target.checked) {
      setInputData({ ...inputData, propertyId: '' });
    }
  };

  const handleSave = async () => {
    if (id !== undefined) {
      let groupLevelData = {
        Updater: 'Dashboard',
        PropertyId: inputData.propertyId,
        Number: inputData.Number
      }
      AxiosAPI({
        method: 'put',
        url: `${putAPI_Update_PhoneIntegration}/${id}?group_id=${getGroupID()}`,
        data: inputData
      }).then((res) => {
        if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
          && res.data.Messages !== null && res.data.Messages.length > 0) {
          setMsg(res.data.Messages);
          setOpen(true);
        }
        else {
          toggle();
          setTimeout(() => {
            window.location.reload();
          }, 300);
        }
        AxiosAPI({
          method: 'put',
          url: `${putAPI_Update_PhoneIngetration_Group}/${id}`,
          data: groupLevelData
        }).then(() =>
          setTimeout(() => {
            window.location.reload();
          }, 300)
        )
      }
      );
      toggle();
    }
    else {
      let groupLevelData = {
        Creator: 'Dashboard',
        PropertyId: inputData.propertyId,
        Number: inputData.Number,
        GroupId: inputData.GroupId
      }
      AxiosAPI({
        method: 'post',
        url: postAPI_Create_PhoneIntegration,
        data: inputData
      }).then((res) => {
        if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
          && res.data.Messages !== null && res.data.Messages.length > 0) {
          setMsg(res.data.Messages);
          setOpen(true);
        }
        else {
          groupLevelData.IntegrationId = res.data.id

          AxiosAPI({
            method: 'post',
            url: `${postAPI_Create_PhoneIntegrationInGroupService}`,
            data: groupLevelData
          }).then(() =>
            setTimeout(() => {
              window.location.reload();
            }, 300)
          )
        }
      });
      toggle();
    }
  };
  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle}>
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              <div className="text-center">
                <h6>{id === undefined ? "Add" : "Update"} Phone Integration</h6>
                <Separator className="mb-3" />
                <Form>
                  <FormGroup className="mb-2 text-left">
                    <Label>Integration Name</Label>
                    <Input
                      type="text"
                      name="integrationName"
                      onChange={handleNameChange}
                      placeholder="Integration Name"
                      defaultValue={inputData.Name}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2 text-left">
                    <Label>Phone Number</Label>
                    <Input
                      type="text"
                      name="number"
                      onChange={handleNumberChange}
                      placeholder="Phone Number"
                      defaultValue={inputData.Number}
                    />
                  </FormGroup>
                  <FormGroup>
                    <div className='integration-property'>
                      {property.map((p, index) => {

                        return (<CustomInput
                          key={p.id}
                          type="radio"
                          id={index}
                          label={p.name}
                          value={p.id}
                          name="property"
                          checked={p.id === inputData.propertyId ? true : false}
                          onChange={handleCheckChange}
                        />)

                      })}
                    </div>
                  </FormGroup>
                </Form>
                <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                  {id === undefined ? (<Button color="primary" size="xs" onClick={handleSave}>
                    Create New Integration
                  </Button>) : (<Button color="primary" size="xs" onClick={handleSave}>
                    Update Integration
                  </Button>)}


                  <Button size="xs" color="dark" outline onClick={toggle}>
                    Cancel
                  </Button>
                </ButtonGroup>
              </div>
            </Colxx>
          </Row>
        </ModalBody>
      </Modal>
      <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
    </Fragment>
  );
}
